module.exports = __webpack_public_path__ + "static/img/1.c44d594.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/1.png
// module id = vRkx
// module chunks = 0